var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToggleSidebar = function SvgToggleSidebar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.375 4.463v1.875H2.625V4.463zm-12.75 8.062h12.75V10.65H8.625zm-6 6.188h18.75v-1.875H2.625zM6.412 8.025l-3.787 3.788L6.412 15.6l1.332-1.33-2.475-2.457 2.456-2.456z"
  })));
};
export default SvgToggleSidebar;